import { render, staticRenderFns } from "./InputUnsignedDecimal.vue?vue&type=template&id=10ccbfce&scoped=true&"
import script from "./InputUnsignedDecimal.vue?vue&type=script&lang=js&"
export * from "./InputUnsignedDecimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ccbfce",
  null
  
)

export default component.exports